import { Link } from "react-router";
import { BIGMONEY_SUBSCRIBE_CTA } from "@components/Newsletter/constants";
import { formatTitle } from "@components/Newsletter/helper";
import HomepageCarouselNewsletterSlide from "@components/Newsletter/HomepageCarouselNewsletter/HomepageCarouselNewsletterSlide";
import { NewsletterSectionProps } from "@components/Newsletter/types/Newsletter";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import NewsletterTitle from "@routes/Newsletter/SignUp/components/NewsletterTitle";

const NewsletterSection = ({
  title,
  newsletters,
  selectedNewsletters,
  handleSelectedNewsletter,
  sectionRef,
  rootClassname,
}: NewsletterSectionProps): React.ReactElement => {
  const { isSubscriber } = useUserInfo();

  const formattedTitle = formatTitle(title);

  return (
    <div>
      <NewsletterTitle
        title={title}
        formattedTitle={formattedTitle}
        sectionRef={sectionRef}
        rootClassname={rootClassname}
      />

      {title == "Premium NEWSLETTERS" && !isSubscriber ? (
        <div className="mb-5 font-public-sans text-[16px] font-normal">
          <Link
            to={BIGMONEY_SUBSCRIBE_CTA}
            target="_blank"
            className="font-public-sans font-semibold underline"
          >
            Subscribe to BT
          </Link>
          {" to access these exclusive newsletters."}
        </div>
      ) : null}

      <div className="mb-11 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {newsletters.map((newsletter) => (
          <HomepageCarouselNewsletterSlide
            wrapperClassName="!mb-0"
            titleClassName="text-xl md:text-3xl"
            descriptionClassName="mb-4 font-normal text-gray-850 md:mb-10"
            testId={newsletter.type}
            key={newsletter.type}
            newsletter={newsletter}
            handleSelectedNewsletter={handleSelectedNewsletter}
            subscribed={selectedNewsletters.some(
              (selectedNewsletter) =>
                selectedNewsletter.type === newsletter.type
            )}
            premiumOnly={newsletter?.premiumOnly}
          />
        ))}
      </div>
    </div>
  );
};

export default NewsletterSection;
